import { Box, Button, Checkbox, Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useAppDispatch } from "store/appHooks";
import { Label, SubTitle, Title } from "../mui.styles";

const labelProp = { inputProps: { "aria-label": "Checkbox demo" } };

const centerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
};
const CustomCheckbox = ({
  id,
  label,
  checked,
  onChange,
  isMobileView,
  Icon,
}: any) => (
  <Box
    key={id}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "10px",
      width: "100%",
    }}
  >
    {!isMobileView && (
      <Checkbox
        onChange={(e) => onChange(e.target.checked)}
        {...labelProp}
        color="primary"
        checked={checked}
      />
    )}
    <img src={Icon} alt="" style={{ height: "32px", width: "32px" }} />

    <Typography sx={{ fontSize: "13px" }}>{label}</Typography>
    {isMobileView && (
      <Checkbox
        sx={{ ml: "auto" }}
        onChange={(e) => onChange(e.target.checked)}
        {...labelProp}
        color="primary"
        checked={checked}
      />
    )}
  </Box>
);

const Configurations = (props: any) => {
  const { currentStep, setCurrentStep, isMobileView, changeStepStatus } = props;
  const {
    setValue,
    control,
    watch,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const values = watch();
  const dispatch = useAppDispatch();

  const {
    has_loader_bucker,
    has_ac,
    has_3point_lift,
    has_heater,
    has_pto,
    has_4wd,
    has_cabin,
    has_power_steering,
  } = values;

  const navigateNext = () => {
    setCurrentStep("Listing Images");
    changeStepStatus(currentStep, "submitted", true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Box sx={{ p: "10px 16px" }}>
      <Title >Features</Title>
      <SubTitle >
        Help us to get know more about your vehicles
      </SubTitle>
      <br />
      <Label >
        Choose Features
      </Label>

      <br />

      <Grid container spacing={3} sx={{ width: "100%", ml: 0 }}>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_loader_bucker", v)}
            id={"Loader Bucket"}
            label={"Loader Bucket"}
            checked={has_loader_bucker}
            {...props}
            Icon={require("assets/img/png/loader_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_3point_lift", v)}
            id={"3 Point Lift"}
            label={"3 Point Lift"}
            checked={has_3point_lift}
            {...props}
            Icon={require("assets/img/png/lift_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_power_steering", v)}
            id={"Power Steering"}
            label={"Power Steering"}
            checked={has_power_steering}
            {...props}
            Icon={require("assets/img/png/power_streering_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_cabin", v)}
            id={"Cabin"}
            label={"Cabin"}
            checked={has_cabin}
            {...props}
            Icon={require("assets/img/png/cabin_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_heater", v)}
            id={"Heater"}
            label={"Heater"}
            checked={has_heater}
            {...props}
            Icon={require("assets/img/png/heater_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_ac", v)}
            id={"AC"}
            label={"AC"}
            checked={has_ac}
            {...props}
            Icon={require("assets/img/png/ac_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_pto", v)}
            id={"PTO"}
            label={"PTO"}
            checked={has_pto}
            {...props}
            Icon={require("assets/img/png/pto_ic.png")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} style={{ ...centerStyle }}>
          <CustomCheckbox
            onChange={(v: boolean) => setValue("has_4wd", v)}
            id={"4WD"}
            label={"4WD"}
            checked={has_4wd}
            {...props}
            Icon={require("assets/img/png/4wd_ic.png")}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="end">
            <Button
              sx={{
                mr: 1.5,
                backgroundColor: "transparent",
                color: "primary.main",
                border: "1px solid #dfdfdf",
              }}
              variant="contained"
              type="submit"
              onClick={() => setCurrentStep("Basic Details")}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={navigateNext}
              // disabled={listingReducer?.submittingListingData}
              // endIcon={
              //   listingReducer.submittingListingData ? (
              //     <CircularProgress size={15} />
              //   ) : null
              // }
            >
              Continue
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Configurations;
